module.exports = __webpack_public_path__ + "img/zhu_xc6.de75a50c.jpg";